var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionStickyscrollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product Selection Table - Desktop"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3368 -228C-3368 -229.105 -3367.1 -230 -3366 -230H21680C21681.1 -230 21682 -229.105 21682 -228V5411C21682 5412.1 21681.1 5413 21680 5413H-3366C-3367.1 5413 -3368 5412.1 -3368 5411V-228Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "D Product Selection Table - Vertical Scroll",
    clipPath: "url(#clip0_1087_205586)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1360,
    height: 1762,
    transform: "translate(-56 -8)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "D Product Selection Table - Sticky Table Tools (Vertical Scroll)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1360,
    height: 1602,
    transform: "translate(-56 48)",
    fill: "#E0E1E6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 843589002",
    filter: "url(#filter0_d_1087_205586)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Sticky Table Header",
    filter: "url(#filter1_dd_1087_205586)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1360,
    height: 56,
    transform: "translate(-56 -8)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component 3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#0067B9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 10V12.2222H28.8889L23.3333 20.5556V30H16.6667V20.5556L11.1111 12.2222H10V10H30ZM13.7822 12.2222L18.8889 19.8822V27.7778H21.1111V19.8822L26.2178 12.2222H13.7822Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M-3366 -229H21680V-231H-3366V-229ZM21681 -228V5411H21683V-228H21681ZM21680 5412H-3366V5414H21680V5412ZM-3367 5411V-228H-3369V5411H-3367ZM-3366 5412C-3366.55 5412 -3367 5411.55 -3367 5411H-3369C-3369 5412.66 -3367.66 5414 -3366 5414V5412ZM21681 5411C21681 5411.55 21680.6 5412 21680 5412V5414C21681.7 5414 21683 5412.66 21683 5411H21681ZM21680 -229C21680.6 -229 21681 -228.552 21681 -228H21683C21683 -229.657 21681.7 -231 21680 -231V-229ZM-3366 -231C-3367.66 -231 -3369 -229.657 -3369 -228H-3367C-3367 -228.552 -3366.55 -229 -3366 -229V-231Z",
    fill: "black",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1087_205586",
    x: -91,
    y: 13,
    width: 1747,
    height: 311,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.145098 0 0 0 0 0.184314 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1087_205586"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1087_205586",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_1087_205586",
    x: -91,
    y: -43,
    width: 1430,
    height: 126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.145098 0 0 0 0 0.184314 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1087_205586"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.145098 0 0 0 0 0.184314 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1087_205586",
    result: "effect2_dropShadow_1087_205586"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1087_205586",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1087_205586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1360,
    height: 1762,
    fill: "white",
    transform: "translate(-56 -8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionStickyscrollIcon);
export default __webpack_public_path__ + "static/media/Accordion-stickyscroll-icon.8f68c1b072690a23d6c0d5d1c99e52c5.svg";
export { ForwardRef as ReactComponent };